import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { IPodcast } from "../../types/podcastType";
import { RootState } from "../store";

// Podcast list cache (no pagination). `cachedForEmail` guards against serving
// one user's content to another — pro podcast URLs are only exposed to
// subscribers with the right plan.
interface PodcastState {
  podcasts: IPodcast[];
  status: "idle" | "loading" | "failed";
  cachedForEmail: string;
  lastFetched: number | null;
}

const initialState: PodcastState = {
  podcasts: [],
  status: "idle",
  cachedForEmail: "",
  lastFetched: null,
};

export const podcastReducer = createSlice({
  name: "podcast",
  initialState,
  reducers: {
    setPodcasts: (
      state,
      action: PayloadAction<{ podcasts: IPodcast[]; email: string }>
    ) => {
      state.podcasts = action.payload.podcasts;
      state.cachedForEmail = action.payload.email;
      state.status = "idle";
      state.lastFetched = Date.now();
    },
    // Background revalidation found nothing new.
    touchPodcasts: (state) => {
      state.lastFetched = Date.now();
      state.status = "idle";
    },
    setPodcastsLoading: (state) => {
      state.status = "loading";
    },
    setPodcastsFailed: (state) => {
      state.status = "failed";
    },
    clearPodcasts: () => initialState,
  },
});

export const {
  setPodcasts,
  touchPodcasts,
  setPodcastsLoading,
  setPodcastsFailed,
  clearPodcasts,
} = podcastReducer.actions;

export const selectPodcast = (state: RootState) => state.podcast;
export const selectPodcasts = (state: RootState) => state.podcast.podcasts;
export const selectPodcastsStatus = (state: RootState) => state.podcast.status;

export default podcastReducer.reducer;
